module.exports = __webpack_public_path__ + "img/ic-message-tab.00bc2fa.svg";